import { createAction } from "@reduxjs/toolkit";

const index = {
  login_request_start: createAction("login_request_start"),
  login_request_success: createAction("login_request_success"),
  login_request_fail: createAction("login_request_fail"),

  register_request_start: createAction("register_request_start"),
  register_request_success: createAction("register_request_success"),
  register_request_fail: createAction("register_request_fail"),

  logout_request_start: createAction("logout_request_start"),
  logout_request_success: createAction("logout_request_success"),
  logout_request_fail: createAction("logout_request_fail"),
  login_request_end: createAction("login_request_end"),
  set: createAction("set"),
  fold: createAction("fold"),
  set_notification: createAction("set_notification"),


  set_loading_true: createAction("set_loading_true"),
  set_loading_false: createAction("set_loading_false"),

  getUsers_request_success: createAction("getUsers_request_success"),
  getUsers_request_fail: createAction("getUsers_request_fail"),
  getUsers_request_start: createAction("getUsers_request_start"),
  getUsers_request_end: createAction("getUsers_request_end"),


  getRoles_request_success: createAction("getRoles_request_success"),
  getRoles_request_fail: createAction("getRoles_request_fail"),
  getRoles_request_start: createAction("getRoles_request_start"),
  getRoles_request_end: createAction("getRoles_request_end"),


  getLanguage_request_success: createAction("getLanguage_request_success"),
  getLanguage_request_fail: createAction("getLanguage_request_fail"),
  getLanguage_request_start: createAction("getLanguage_request_start"),
  getLanguage_request_end: createAction("getLanguage_request_end"),



  setCategroy: createAction("categoryState/setCategroy"),
  setSubCategroy: createAction("setSubCategroy"),

};
export default index;
